import dat from 'dat.gui'

export const gui = new dat.GUI()
gui.close()

export let guiObj = {
  envMap: true
}